import React, { ReactNode } from "react";

import HeadlineSection from "../HeadlineSection";
import { HeadlineSectionProps } from "../HeadlineSection/HeadlineSection";
import background from "../../statics/img/background.jpg";

export interface HeroSectionProps {
  headline: HeadlineSectionProps;
  children?: ReactNode;
}

const HeroSection = ({ headline, children }: HeroSectionProps) => {
  return (
    <div
      className="bg-center bg-no-repeat bg-cover lg:flex"
      style={{
        backgroundImage: `url(${background})`,
      }}
    >
      <div
        className={`w-full text-white ${
          children !== undefined ? "lg:w-5/12" : ""
        }`}
      >
        <HeadlineSection {...headline} />
      </div>
      {children}
    </div>
  );
};

export default HeroSection;
